import { css, createGlobalStyle } from 'styled-components';
import { circularFonts, iconFont } from './font-face.js';
import { cssReset } from './reset.js';

const globalComponentCss = css`
  body.dialog-open {
    overflow: hidden;
  }
`;
/**
 * All Brandfolder global styles (reset, Circular font, and icon font)
 */ const BrandfolderGlobalStyles = createGlobalStyle`
  ${cssReset}
  ${circularFonts}
  ${iconFont}
  ${globalComponentCss}
`;
/**
 * Brandfolder global reset
 */ const BrandfolderGlobalReset = createGlobalStyle`
  ${cssReset}
`;
/**
 * Brandfolder Circular font
 */ const BrandfolderGlobalCircularFont = createGlobalStyle`
  ${circularFonts}
`;
/**
 * Brandfolder icon font
 */ const BrandfolderGlobalIconFont = createGlobalStyle`
  ${iconFont}
`;
/**
 * Brandfolder global fonts (Circular font and icon font)
 */ const BrandfolderGlobalFonts = createGlobalStyle`
  ${circularFonts}
  ${iconFont}
`;
/**
 * Brandfolder global component styles.
 * Required for dialog component.
 */ const BrandfolderGlobalComponentStyles = createGlobalStyle`
  ${globalComponentCss}
`;

export { BrandfolderGlobalCircularFont, BrandfolderGlobalComponentStyles, BrandfolderGlobalFonts, BrandfolderGlobalIconFont, BrandfolderGlobalReset, BrandfolderGlobalStyles };
//# sourceMappingURL=global.js.map
